module.exports = __webpack_public_path__ + "assets/img/doctor002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctor002.png
// module id = 1926
// module chunks = 0